import ApiInstance from "@/services/api/api.utils";
import {
  parseBusinessTypeModel,
  parseDutyModel,
  parseRegionModel,
} from "@/services/models/masterData";
import { map } from "lodash";

export const getBusinessType = async () => {
  const res = await ApiInstance.get("/business-types");
  const parsed = map(res, (item) => ({ ...item, type: "businessType" }));
  return parsed;
};

export const getAllBusinessType = async () => {
  const res = await ApiInstance.get("/business-types/all");
  const parsed = map(res, parseBusinessTypeModel);
  return parsed;
};

export const getAllDuty = async () => {
  const res = await ApiInstance.get("/duties/all");
  const parsed = map(res, parseDutyModel);
  return parsed;
};

export const getCities = async (countryCode = "KR") => {
  const res = await ApiInstance.get("/cities", { params: { countryCode } });
  return res;
};

export const getDistricts = async (city) => {
  const res = await ApiInstance.get("/districts", { params: { city } });
  return res;
};

export const getCompanyType = async () => {
  const res = await ApiInstance.get("/company-type");
  const parsed = map(res, (item) => ({ ...item, type: "companyType" }));
  return parsed;
};

export const getRegions = async (countryCode = "KR") => {
  const res = await ApiInstance.get("/cities/districts", {
    params: { countryCode },
  });
  const parsed = map(res, parseRegionModel);
  return parsed;
};

export const getCityDistrictList = async (countryCode = "KR") => {
  const res = await ApiInstance.get("/cities/getCityDistrictList", {
    params: { countryCode },
  });
  const parsed = map(res, parseRegionModel);
  return parsed;
};

export const getWorkTypes = async () => {
  const res = await ApiInstance.get("/work-types");
  return res;
};

export const getAllWorkTypes = async () => {
  const res = await ApiInstance.get("/work-types");
  let parsed = res;
  if (Array.isArray(res)) {
    parsed = [
      {
        _id: "all",
        name: {
          en: "Total",
          ko: "Total",
        },
        order: 0,
      },
      ...res,
    ];
  }
  parsed = map(res, (item) => ({ ...item, type: "workType" }));
  return parsed;
};
export const getJobDuty = async () => {
  const res = await ApiInstance.get("/duties");
  return res;
};

export const getCareers = async () => {
  const res = await ApiInstance.get("/careers");
  const parsed = map(res, (item) => ({ ...item, type: "career" }));
  return parsed;
};

export const getSubBusinessType = async (businessType) => {
  const res = await ApiInstance.get("/sub-business-types", {
    params: { businessType },
  });
  return res;
};

export const getPositions = async () => {
  const res = await ApiInstance.get("/positions");
  return res;
};

export const getSubJobDuties = async (duty) => {
  const res = await ApiInstance.get("/sub-duties", { params: { duty } });
  return res;
};

export const getInquiryTypes = async () => {
  const res = await ApiInstance.get("/kind-inquiries");
  return res;
};

export const getBrands = async () => {
  const res = await ApiInstance.get("/brands");
  return res;
};

export const getBrandToFilterCorporate = async () => {
  const res = await ApiInstance.get("/brands");
  const parsed = map(res, (item) => ({ ...item, type: "brand" }));
  return parsed;
};

export const getEventTypes = async () => {
  const res = await ApiInstance.get("/event-types");
  return res;
};

export const getSubwayCity = async () => {
  const res = await ApiInstance.get("/subways/listCities");
  return res;
};

export const getSubwayLine = async (params) => {
  const res = await ApiInstance.get("/subways/lines", { params });
  return res;
};

export const getSubwayStation = async (params) => {
  const res = await ApiInstance.get("/subways/stations", { params });
  return res;
};
